import React from 'react';
import ComingSoon from '../components/ComingSoon';
import './PageStyles.scss';

const LeaveManagement: React.FC = () => {
  return (
    <div className="hr-portal-page">
      <div className="hr-portal-page-header">
        <h2>Leave Management</h2>
        <p className="page-description">Manage employee leave requests and approvals</p>
      </div>
      <div className="hr-portal-page-content">
        <ComingSoon title="Coming Soon" />
      </div>
    </div>
  );
};

export default LeaveManagement;
